// Reglas de la cinta de la bandeja de tickets. El número de cada tarjeta y la lista que se abre al pulsarla salen de la
// MISMA función, para que nunca se contradigan.

/** Estados en que el siguiente paso es del agente. «Esperando Usuario» no: ahí la pelota está en el lado de quien pidió. */
export const ESTADOS_ACCION_AGENTE = ['Pendiente', 'Asignado', 'En Proceso'];

export const esCerrado = (t) => t.estado === 'Resuelto' || t.estado === 'Cerrado';

/** ¿El ticket está asignado a esta persona? Se compara por id y, si no, por correo. */
export function esMio(t, user) {
  if (!user) return false;
  const correo = user.email ? user.email.toLowerCase() : null;
  return (
    (user.id != null && (t.asignadoAId === user.id || t.asignadoA?.id === user.id)) ||
    (correo != null && t.asignadoA?.email?.toLowerCase() === correo)
  );
}

/** «Esperando por mí»: asignado a mí, sin cerrar y en un estado que me toca atender. */
export const esperaPorMi = (t, user) => esMio(t, user) && ESTADOS_ACCION_AGENTE.includes(t.estado);
